<template>
<div v-if="show" :class="classes" :style="styling">
  <div class="LoadingBar-glow"></div>
</div>
</template>

<script>
export default {
  props: {
      id: String
  },

  data() {

    return {
      // To show
      show: false,

      // binding class when it end
      full: '',

      // state to animate the width of loading bar
      width: 0,

      // indicate the loading bar is in 100% ( so, wait it till gone )
      wait: false,

      // Error State
      myError: false,

      esting: 0,

      _animationLoop: null,

      FRAME_TIME: 10
    }

  },

  computed: {

    classes() {
      return 'LoadingBar LoadingBar--to_right' +
                ( this.myError ? 'LoadingBar--error' : '' ) +
                ( this.full ? 'LoadingBar--full' : '')
    },

    styling() {
      // When loading bar still in progress
      if(!this.wait){
        return { width: `${this.width}%` };
      // When loading bar end
      }else{
        // Make it stuck at 100 to waiting the animation
        return { width: `100%` };
      }
    },

  },

  watch: {
  },

  methods: {
    // Check whether the proggress is full
    isFull() {
      // Full Indicator
      let isFull = this.width >= 100

      // When the progress end or full
      if(isFull){
        if (this._animationLoop) {
          cancelAnimationFrame(this._animationLoop);
        }

        // Prevent new progress change
        this.wait = true

        // Start animate it
        setTimeout(() => {

          // animate when element removed
          this.full = true
          this.myError = false

          setTimeout(() => {
            //remove bar element
            this.show = false
            // New Element is available to create now
            this.width = 0
            this.wait = false

          // Duration to Waiting for slick hiding animation
          },250);

        // Duration is depend on css animation-duration of loading-bar
        },700);
      }
    },

    jump(val) {
      this.show = true;
      this.width = val;
      this.isFull();
    },

    trigger() {
      this.show = true;

      var self = this;

      function animate() {
        let step = 10;
        if (self.esting > 0) {
          if (self.width > 20) {
            step *= 0.9;
          }
          if (self.width > 40) {
            step *= 0.8;
          }
          if (self.width > 50) {
            step *= 0.6;
          }
          if (self.width > 60) {
            step *= 0.4;
          }
          if (self.width > 70) {
            step *= 0.3;
          }
          if (self.width > 80) {
            step *= 0.3;
          }
          if (self.width > 90) {
            step *= 0.3;
          }
          if (self.width > 95) {
            step *= 0.2;
          }
          if (self.width > 99) {
            step = 0;
          }
        }

        self.width += step;
        self.isFull();
      };

      var then = new Date;
      (function frame() {
          self._animationLoop = requestAnimationFrame(frame)
          var now = new Date;
          var delta = now - then;
          if (delta > self.FRAME_TIME) {
              then = now - (delta % self.FRAME_TIME);
              animate();
          }
      })()
    },

    punch(esting) {
      if (esting) {
        this.esting = esting;
      }
      else {
        this.esting += 1;
      }
      this.trigger();
    },

    done() {
      this.esting -= 1;
      if (this.esting < 0) { this.esting = 0; }
    }
  },

  mounted() {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LoadingBar.vue